<template>
  <Dropdown stretch stickRight closeOnClick openDirection="bottom">
    <template #wrapper>
      <PropertyTile :label="label" interactive class="min-h-23 w-full">
        <UserAvatar
          :user="user"
          :withStar="withStar"
          withDayoffBadge
        />
        <span class="line-clamp-2 min-h-[2lh] text-label font-bold leading-tight text-text">
          {{ user ? user.username : t('search.unassigned') }}
        </span>
      </PropertyTile>
    </template>

    <template #items>
      <AppSearchBox
        class="w-64"
        :items="items"
        :getSearchText="item => userSearchText(item, t('task.Unassign'))"
        :placeholder="t('task.SEARCH_ASSIGNEE')"
        @select="emit('select', $event)"
      >
        <template #item="{ item }">
          <UserAvatar withDayoffBadge :user="item" />
          <div class="truncate text-left">{{ item ? item.username : t('task.Unassign') }}</div>
        </template>
      </AppSearchBox>
    </template>
  </Dropdown>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import AppSearchBox from '@/components/elements/AppSearchBox';
import PropertyTile from './PropertyTile';
import { userSearchText } from '@/utils';

defineProps({
  label: {
    type: String,
    required: true,
  },
  user: [Object, null],
  items: {
    type: Array,
    required: true,
  },
  // only the executor avatar carries the star badge
  withStar: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['select']);

const { t } = useI18n();
</script>

